import gql from 'graphql-tag';
import axios from 'axios';

const UploadPlotImageMutation = gql`
  mutation uploadPlotImage {
    data: uploadPlotImage {
      success
      image {
        url
        uploadUrl
      }
    }
  }
`;

export const uploadImage = async (client, params, isEvent = false) => {
  const url = await client.mutate({
    mutation: UploadPlotImageMutation,
  });

  const uploadUrl = url?.data.data.image.uploadUrl;

  // The imageKey what need to send to the backend
  const accessUrl = url?.data.data.image.url;

  // Plot and Event uses the same image upload mutation
  // but in Event schema the image field defined as plotImage:string
  const file = isEvent
    ? params.data.plotImage.rawFile
    : params.data.image.rawFile;

  const response = await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });

  return accessUrl;
};
